import classNames from "classnames";
import { OptionTemplate } from "shared/api/middleware-api-client";
import OptionConfigurationImage from "shared/ui/option-configuration-image";
import Text from "shared/ui/typography/Text";
import { getFormattedPrice } from "shared/utils/getFormattedPrice";
import Icon, { IconTypes } from "../../../shared/ui/icon";
import { useHandleHelper } from "../helpers/useHandleHelper";
import { getHandlePresentation } from "app/providers/handlePolicy";

export const HandleList = () => {
  const {
    doorOptionsLoading,
    doorOptionsLoadError,
    doorOptions,
    isFrameSteel,
    isFrameWood,
    selfAssembleDoorData,
    onUpdateHandle,
    searchParams,
    layout,
    selectedDoor,
    anchorBeamGap,
    selfAssemblyUHandleDisableCodes,
  } = useHandleHelper();
  const layoutCode = layout?.code;

  return (
    <>
      {doorOptionsLoading ? (
        <div>Loading...</div>
      ) : doorOptionsLoadError ? (
        <div>Error!</div>
      ) : (
        <>
          {doorOptions?.handle.map((handle: OptionTemplate, id: number) => {
            // check if handle is wood or steel
            const isHandleWood = handle.code === "verticalhandlehout";
            const isHandleSteel = handle.code === "verticalhandle";

            // frame steel selected => dont render wood handle
            if (
              isFrameSteel &&
              isHandleWood &&
              selfAssembleDoorData.selfAssembly
            ) {
              return null;
            }
            // frame wood selected => dont render steel handle
            if (
              isFrameWood &&
              isHandleSteel &&
              selfAssembleDoorData.selfAssembly
            ) {
              return null;
            }

            //Disable U-Vorm handle for self assembly doors
            if (
              selfAssembleDoorData.selfAssembly &&
              selfAssemblyUHandleDisableCodes.includes(handle.code) &&
              !isHandleSteel
            ) {
              return null;
            }

            const handlePresentation = getHandlePresentation({
              anchorBeamGap,
              doorCode: selectedDoor?.code,
              handleCode: handle.code,
              layoutCode,
            });

            if (handlePresentation === "hidden") {
              return null;
            }

            const isPolicyDisabledHandle = handlePresentation === "disabled";

            // if handle is selected or default handle is selected
            const isHandleSelected =
              handle.code === searchParams.get("handle") ||
              (handle.default &&
                (searchParams.get("handle") === null ||
                  searchParams.get("handle") === ""));
            return (
              <button
                aria-pressed={isHandleSelected}
                className="gg-max-w-min gg-text-left disabled:gg-cursor-not-allowed"
                key={`handle-${id}`}
                onClick={() => onUpdateHandle(handle)}
                disabled={isPolicyDisabledHandle}
                data-testid={`door-handle-option-${handle.code}`}
              >
                <div className="gg-relative gg-aspect-square gg-w-24">
                  <OptionConfigurationImage
                    imageId={handle.imageId}
                    className={classNames(
                      "gg-mb-1.5 gg-h-full gg-w-full gg-rounded gg-border gg-transition gg-duration-300 gg-ease-in-out",
                      {
                        "gg-border-[#9493A3]": isHandleSelected,
                        "gg-border-[#EAE9ED]": !isHandleSelected,
                        "hover:gg-scale-[1.015] hover:gg-border-[#9493A3]":
                          !isPolicyDisabledHandle,
                        "gg-opacity-60": isPolicyDisabledHandle,
                      },
                    )}
                  />
                  {isHandleSelected ? (
                    <Icon
                      name={IconTypes.WHITE_CHECK}
                      alt=""
                      className={
                        "gg-absolute -gg-top-2.5 gg-left-full gg-z-20 gg-aspect-square gg-w-5 -gg-translate-x-2.5 gg-rounded-full gg-bg-green-500 gg-p-1.5"
                      }
                    />
                  ) : null}
                </div>

                <Text className="gg-mb-1 gg-w-20 gg-text-xs gg-font-bold">
                  {handle.name}
                </Text>

                <Text className="gg-text-xs gg-text-secondary-text">
                  {getFormattedPrice(handle.price)}
                </Text>
              </button>
            );
          })}
        </>
      )}
    </>
  );
};
